export const sourcecode1 = `<vm-input v-model="input" placeholder="请输入内容"></vm-input>

<script>
export default {
  data() {
    return {
      input: ''
    }
  }
}
</script>`

export const sourcecode2 = `<vm-input
  placeholder="请输入内容"
  v-model="input1"
  :disabled="true">
</vm-input>

<script>
export default {
  data() {
    return {
      input1: ''
    }
  }
}
</script>`

export const sourcecode5 = `<vm-input 
  v-model="input2" 
  placeholder="请输入内容" 
  icon="vm-input-icon-search" 
  :onIconClick="handleIconClick">
</vm-input>

<script>
export default {
  data() {
    return {
      input2: ''
    }
  },
  methods:{
    handleIconClick(e){
      console.log(e)
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'vm-input-font';
  src: url('../font/iconfont.eot');
  src: url('../font/iconfont.eot?#iefix') format('embedded-opentype'),
  url('../font/iconfont.woff') format('woff'),
  url('../font/iconfont.ttf') format('truetype'),
  url('../font/iconfont.svg#iconfont') format('svg');
}

.vm-input-icon-search{
  display: inline-block;
  font-family:"vm-input-font" !important;
  font-size:16px;
  font-style:normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.vm-input-icon-search:before { content: "\e66f"; }
</style>
`
export const sourcecode3 = `<vm-input
  type="textarea"
  :rows="2"
  placeholder="请输入内容"
  v-model="textarea">
</vm-input>

<script>
export default {
  data() {
    return {
      textarea: ''
    }
  }
}
</script>`
export const sourcecode4 = `<vm-input
  type="textarea"
  autosize
  placeholder="请输入内容"
  v-model="textarea2">
</vm-input>
<div style="margin: 20px 0;"></div>
<vm-input
  type="textarea"
  :autosize="{ minRows: 2, maxRows: 4}"
  placeholder="请输入内容"
  v-model="textarea3">
</vm-input>

<script>
export default {
  data() {
    return {
      textarea2: '',
      textarea3: ''
    }
  }
}
</script>`


// WEBPACK FOOTER //
// ./example/src/template.js